import React, { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import AppButton from "../buyer/AppButton";
import theme from "../../styles/theme/theme";
import { FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { disputeOrder } from "../../features/buyer/buyerSlice";
import { showAppMessageToast } from "../../utils/toastUtils";

const MAX_IMAGES = 5;

const RaiseDisputeModal = ({ show, onHide, onSuccess, orderId }) => {
  const [reason, setReason] = useState("");
  const [images, setImages] = useState([]);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.buyer.disputeLoading);

  console.log("Order Id in Modal:", orderId);

  useEffect(() => {
    if (!show) {
      setReason("");
      setImages([]);
    }
  }, [show]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const remainingSlots = MAX_IMAGES - images.length;

    if (remainingSlots <= 0) return;

    const selected = files.slice(0, remainingSlots);
    const previews = selected.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setImages((prev) => [...prev, ...previews]);
  };

  const removeImage = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleCancel = () => {
    onHide();
  };

  const handleSend = async () => {
    if (!reason.trim()) return;

    const payload = {
      reason,
      images: images.map((img) => img.file),
    };
    console.log("Dispute Payload:", payload);
    onSuccess?.(payload);
    onHide();

    if (!reason.trim()) return;

    console.log("Dispute Order ID:", orderId);
    const formData = new FormData();
    formData.append("order_id", orderId);
    formData.append("reason", reason);

    images.forEach((img) => {
      formData.append("images[]", img.file);
    });

    try {
      await dispatch(disputeOrder({ id: orderId, data: formData })).unwrap();
      showAppMessageToast({
        type: "success",
        title: "Dispute Raised",
        message: "Your dispute has been submitted successfully.",
      });
      onSuccess?.();
    } catch (err) {
      showAppMessageToast({
        type: "error",
        title: "Dispute Failed",
        message: err || "Something went wrong.",
      });
    }
  };

  return (
    <Modal show={show} onHide={handleCancel} centered>
      {/* Header */}
      <Modal.Header
        style={{
          backgroundColor: theme.palette.background.paper,
          borderBottom: `2px solid ${theme.palette.secondary.main}`,
        }}
      >
        <Modal.Title
          style={{
            fontWeight: 600,
            fontSize: "1.25rem",
            color: theme.palette.text.primary,
          }}
        >
          Raise a Dispute
        </Modal.Title>
      </Modal.Header>

      {/* Body */}
      <Modal.Body style={{ backgroundColor: theme.palette.background.paper }}>
        {/* Reason */}
        <Form.Group className="mb-3">
          <Form.Label style={{ color: theme.palette.text.primary }}>
            Reason
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            placeholder="Describe the issue with your order..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            style={{
              fontSize: "0.95rem",
              backgroundColor: theme.palette.background.paper,
            }}
          />
        </Form.Group>

        {/* Image Upload */}
        <Form.Group className="mb-2">
          <Form.Label style={{ color: theme.palette.text.primary }}>
            Upload Images (upto {MAX_IMAGES} max)
          </Form.Label>
          <Form.Control
            type="file"
            accept="image/*"
            multiple
            disabled={images.length >= MAX_IMAGES}
            onChange={handleImageChange}
          />
        </Form.Group>

        {/* Image Preview */}
        {images.length > 0 && (
          <div style={styles.previewContainer}>
            {images.map((img, index) => (
              <div key={index} style={styles.previewItem}>
                <img
                  src={img.preview}
                  alt="preview"
                  style={styles.previewImage}
                />
                <button
                  type="button"
                  style={styles.removeBtn}
                  onClick={() => removeImage(index)}
                >
                  <FaTimes size={12} />
                </button>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>

      {/* Footer */}
      <Modal.Footer
        style={{
          backgroundColor: theme.palette.background.paper,
          borderTop: `2px solid ${theme.palette.secondary.main}`,
        }}
      >
        <div style={styles.modalButtons}>
          <AppButton
            variant="outlined"
            onClick={handleCancel}
            style={{ marginRight: 12 }}
          >
            Cancel
          </AppButton>
          <AppButton
            variant="contained"
            onClick={handleSend}
            disabled={!reason.trim()}
          >
            Send
          </AppButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default RaiseDisputeModal;

const styles = {
  modalButtons: {
    width: 250,
    display: "flex",
    justifyContent: "flex-end",
  },
  previewContainer: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
    marginTop: 8,
  },
  previewItem: {
    position: "relative",
    width: 60,
    height: 60,
    borderRadius: 8,
    overflow: "hidden",
    border: "1px solid #ddd",
    backgroundColor: "#f5f5f5",
  },
  previewImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  removeBtn: {
    position: "absolute",
    top: 4,
    right: 4,
    background: "rgba(0,0,0,0.6)",
    border: "none",
    borderRadius: "50%",
    width: 18,
    height: 18,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#fff",
    zIndex: 2,
  },
};
